import s from './traders-discount.module.css';

function TradersDiscount() {
    return (
        <div className={s.tradersDiscount}>Traders 33% cheaper</div>
    );
}

export default TradersDiscount;
